import { MoonFill, BrightnessHighFill, ArrowClockwise } from 'react-bootstrap-icons'
import { Button, Modal } from 'react-bootstrap'
import useLocalStorage from "use-local-storage";
import MessagesOffCanvas from './MessagesOffCanvas'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useLayoutEffect, useState } from 'react';
import ApiSettingsDialog from './ApiSettings';
import CenterSettingsDialog from './CenterSettings/CenterSettingsDialog';
import { centerClient } from '../shared/clients';
import { InformationDialog } from './InformationDialog';
import { LoadingSpinner } from './LoadingSpinner';
import { useAuth } from 'blick.react.utils';
import { router } from '../router';
import { LogoutOutlined, Settings } from '@mui/icons-material';
import { useIsMobile } from './shared';
import { FindDeviceModal } from './Administration/forms/FindDeviceForm';
import context, { darkTheme, lightTheme } from './Administration/context/shared';
import { observer } from 'mobx-react-lite';

interface MobileProps {
    theme: string;
    switchTheme: () => void;
    version: string;
    setInfoDialogVisible: (v: boolean) => void;
    authSignOut: () => void;
}

export const Mobile = ({ theme, switchTheme, version, setInfoDialogVisible, authSignOut }: MobileProps) => {
    const [settingsVisible, setSettingsVisible] = useState(false);
    const { refreshTree } = context;
    return (
        <div className="marginBottom" style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }} >
            <Button variant="custom" title="Обновить" className="mobileToolsRefresh" onClick={refreshTree}>
                <ArrowClockwise />
            </Button>
            <div style={{ marginRight: 'auto' }} />
            <FindDeviceModal />
            <Button variant="custom" onClick={() => setSettingsVisible(true)} >
                <Settings />
            </Button>
            <MessagesOffCanvas />
            <Modal backdrop={true} show={settingsVisible} onHide={() =>
                setSettingsVisible(false)}>
                <Modal.Header style={{ width: '100%'}} closeButton>
                    <Modal.Title style={{ width: '100%' }}>
                        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                            <label>Настройки</label>
                            <label onClick={() => setInfoDialogVisible(true)}>Версия {version}</label>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <ApiSettingsDialog buttonVariant="custom" buttonText="Настройки API" />
                        <Button className="marginTop switchTheme" variant="custom" onClick={switchTheme}>
                            {theme == "dark" ? <MoonFill /> : <BrightnessHighFill />}
                            Сменить тему
                        </Button>
                        <Button style={{marginTop:"5rem"}} variant="custom" title="Выйти" onClick={authSignOut}>
                            <LogoutOutlined />
                            Выход из приложения
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export const ToolsPanel = observer(() => {
    const { theme, setTheme } = context;
    const [version, setVersion] = useState('');
    const [infoDialogVisible, setInfoDialogVisible] = useState(false);
    const auth = useAuth(router)

    const switchTheme = () => {
        setTheme(theme == lightTheme ? darkTheme : lightTheme);
    };
    useEffect(() => {
        centerClient.getAppVersion()
            .then((res) => {
                const data = res.data;
                if (data)
                    setVersion(data.Version!);
            })
            .catch(() => void 0);
    }, [])

    return (
        <>
            {
                useIsMobile() ?
                    <Mobile
                        theme={theme}
                        switchTheme={switchTheme}
                        version={version}
                        setInfoDialogVisible={setInfoDialogVisible}
                        authSignOut={auth.signOut}
                    /> :
                    <div id="toolsPanel">
                        <LoadingSpinner />
                        <label onClick={() => setInfoDialogVisible(true)}>Версия {version}</label>
                        <CenterSettingsDialog buttonVariant='transparent' />
                        <ApiSettingsDialog buttonVariant='transparent' />
                        <Button variant="transparent" className="switchTheme" onClick={switchTheme}>
                            {theme == darkTheme ? <MoonFill /> : <BrightnessHighFill />}
                        </Button>
                        <MessagesOffCanvas />
                        <Button variant="transparent" title="Выйти" onClick={auth.signOut}>
                            <LogoutOutlined />
                        </Button>
                    </div>
            }
            <InformationDialog visible={infoDialogVisible} setVisible={setInfoDialogVisible} />
        </>

    )
})
